import React from "react";
import styled from "styled-components";

export const inputWithSuffix = (Component) => (props) => {
  return (
    <Container>
      <Component {...props} />
      <SuffixStyle>{props.suffix}</SuffixStyle>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-items: end;
`;
const SuffixStyle = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 5px;
  z-index: 10;
  font-size: small;
  white-space: nowrap;
  height: 100%;
  background-color: #fff;
`;
